import { Link } from "gatsby"
import React from "react"

type BreadCrumbProps = {
  links: {
    title: string
    uri?: string
  }[]
}

export const BreadCrumb = ({ links }: BreadCrumbProps) =>
  links.map(({ uri, title }, index) =>
    uri ? (
      <Link to={uri} key={uri}>
        {index ? " › " : ""}
        {title}
      </Link>
    ) : (
      <span key={title}>
        {index ? " › " : ""}
        {title}
      </span>
    )
  )
